import { init as sentryInit } from '@do/seashell/utils';
import React from 'react';
import ReactDOM from 'react-dom';
import { Helmet } from 'react-helmet';
import App from './App';
import copy from './copy';

sentryInit(
  'https://6ae96b6dd8c740a3969e0cd97bb1ddb8@o45439.ingest.sentry.io/6071125'
);

ReactDOM.render(
  <>
    <Helmet
      defaultTitle={copy.pageTitles.defaultTitle}
      titleTemplate={copy.pageTitles.titleTemplate}
    />
    <App />
  </>,
  document.getElementById('root')
);
